interface RoktAttributes {
  email: string
  conversiontype: string
}

export const setRoktAttributes = async ({ email, ...rest }: RoktAttributes): Promise<void> => {
  const shajs = await import('sha.js').then(mod => mod.default)
  const emailsha256 = shajs('sha256').update(email.toLowerCase()).digest('hex')

  return window.rokt?.setAttributes?.({
    ...rest,
    emailsha256
  })
}

export const triggerRoktPageChange = (pageIdentifier: string): void => {
  window.rokt?.triggerPageChange?.({
    pageIdentifier
  })
}

export const closeAllRoktPlacements = (): void => {
  window.rokt?.closeAll?.()
}
